var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreysclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#DDD8D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8757 16.6967C17.5503 16.3713 17.0226 16.3713 16.6972 16.6967C16.3718 17.0222 16.3718 17.5498 16.6972 17.8752L20.822 22L16.6972 26.1248C16.3718 26.4502 16.3718 26.9779 16.6972 27.3033C17.0226 27.6288 17.5503 27.6288 17.8757 27.3033L22.0005 23.1785L26.1253 27.3033C26.4507 27.6288 26.9784 27.6288 27.3038 27.3033C27.6292 26.9779 27.6292 26.4502 27.3038 26.1248L23.179 22L27.3038 17.8752C27.6292 17.5498 27.6292 17.0222 27.3038 16.6967C26.9784 16.3713 26.4507 16.3713 26.1253 16.6967L22.0005 20.8215L17.8757 16.6967Z",
    fill: "#4B4F57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreysclose);
export default __webpack_public_path__ + "static/media/greysclose.c42cc90637b0635a6c89ea300e527d42.svg";
export { ForwardRef as ReactComponent };